import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-travel-bill-menu',
  templateUrl: './travel-bill-menu.component.html',
  styleUrls: ['./travel-bill-menu.component.css']
})
export class TravelBillMenuComponent implements OnInit {
    travelBillNo;

    public selectedBgTravelBillMenuMain: string = 'OVERVIEW';

    public menu?: Menu;

    public itemsListTravelBills: Item[] = [];

    public sending = false;

    public approving = false;

    public specialHrsNoButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'sroperation', gotoParms: () => this.menu!.custact_no ?? '' }];

    public customerNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.menu!.cust_no ?? '' }];

    public projectNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'projectmenu', gotoParms: () => this.menu!.project_keyno ?? '' }];

    public customerActivityNoteButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'workdetails', gotoParms: () => this.menu!.custact_no ?? '' }];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.travelBillNo = this.stateService.getStateParams()['travelbill_no'];
    }

    private async loadMenu() {
        if (!!this.travelBillNo) {
            this.menu = (await this.datatask.Post(1254, { travelbill_no: this.travelBillNo }))[0];
        }
    }

    private async loadTravelBills() {
        if (!this.menu) return;

        this.itemsListTravelBills = await this.datatask.Post(1257, { travelbill_no: this.menu.travelbill_no });
    }

    public async sendChanges() {
        if (!!this.menu) {
            try {
                this.sending = true;

                const response = (await this.datatask.Post(1324, { travelbill_no: this.menu.travelbill_no }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.sending = false;
            }
        }
    }

    public async approveChanges() {
        if (!!this.menu) {
            try {
                this.approving = true;

                const response = (await this.datatask.Post(1325, { travelbill_no: this.menu.travelbill_no }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.approving = false;
            }
        }
    }

    public async goToFunc(state: any) {
        if (!this.menu) return;

        switch (state) {
            case 'travelexpence':
                const response = (await this.datatask.Post(678, { counter_id: 'travelexpence_keyno' }))[0];

                this.stateService?.go('travelexpence', {
                    travelbill_no: this.menu?.travelbill_no,
                    travelexpence_keyno: response?.nextnumber
                });
                break;
            case 'travelbillreject':
                this.stateService?.go('travelbillreject', { travelbill_no: this.menu?.travelbill_no });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadTravelBills();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    travelbill_no: string;
    labour_no: string;
    labour_name: string;
    cust_name: string;
    project_name: string;
    destination: string;
    start_dt: string;
    end_dt: string;
    place_of_departure: string;
    travel_goal: string;
    custact_no: string;
    custact_note: string;
    projectprosess_id_and_name: string;
    project_keyno: string;
    cust_no: string;
    diet_days: string;
    diet_hours: string;
    nights: string;
    nbr_of_days: string;
    isexpence: string;
    sum_total: string;
    page_heading: string;
    special_hrsno: string;
    sr: string;
    approval_status_id: string;
    show_button_send_in: string;
    show_buttons_approval: string;
    special_resource_name_from: string;
    special_resource_name_processing: string;
}
